import { useAtom } from 'jotai'
import { useState } from 'react'
import { colorModeAtom } from '~/states/atoms/Theme'

import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import {
  Chip,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material'

/**
 * AppBar 用の設定（ギア）メニュー。
 * ダークモードの切り替えを行う。
 */
export function ColorModeMenu() {
  const [mode, setMode] = useAtom(colorModeAtom)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const isDark = mode === 'dark'

  const toggleMode = () => setMode(isDark ? 'light' : 'dark')

  return (
    <>
      <Tooltip title="設定">
        <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)} aria-label="設定">
          <SettingsOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { minWidth: 220, mt: 1 } } }}>
        <Typography variant="caption" color="text.secondary" sx={{ px: 2, py: 0.5, display: 'block' }}>
          表示設定
        </Typography>
        <Divider />
        <MenuItem onClick={toggleMode} sx={{ py: 1 }}>
          <ListItemIcon>
            {isDark ? <DarkModeOutlinedIcon fontSize="small" /> : <LightModeOutlinedIcon fontSize="small" />}
          </ListItemIcon>
          <ListItemText sx={{ mr: 1 }}>ダークモード</ListItemText>
          <Chip
            label="プレビュー"
            size="small"
            color="info"
            variant="outlined"
            sx={{ height: 18, fontSize: '0.6rem', mr: 1 }}
          />
          <Switch edge="end" size="small" checked={isDark} />
        </MenuItem>
      </Menu>
    </>
  )
}
